module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-16-5a11dc8ca7691e5d597b2b55dfb70783.jpg";